import { DietMealModel } from 'src/app/core/model/object/diet-model';
import { FoodLogModel } from './foodlog-model';
import { Weightlog } from './../api-response/weight-log-response-model';
import { Waterlog } from './../api-response/water-log-response-model';
import { DietDayModel } from './diet-model';
import { BlogUserModel } from './blog-user-model';

export class BlogPostModel {
  constructor(
    public id: string,
    public createdAt: string,
    public comments: number,
    public likes: number,
    public isLiked: boolean,
    public user: BlogUserModel,
    public text?: string,
    public featuredImagePath?: string,
    public featured?: boolean
  ) {}
}

export class BlogPostDetailObsModel {
  constructor(public type: string, public id: string, public postId: string) {}
}

export class BlogListModel {
  constructor(
    public posts?: Array<BlogPostModel>,
    public users?: Array<BlogUserModel>,
    public count?: number
  ) {}
}

export class BlogTagModel {
  constructor(
    public _id: string,
    public title: string,
    public postCount: number
  ) {}
}

export class BlogCommentModel {
  constructor(
    public id: string,
    public text: string,
    public user: BlogUserModel,
    public replies: Array<BlogReplyModel>,
    public repliesPage: number,
    public createdAt: string
  ) {}
}

export class BlogCommentsArrayModel {
  constructor(public comments: Array<BlogCommentModel>, public count: number) {}
}

export class BlogReplyModel {
  constructor(
    public id: string,
    public text: string,
    public user: BlogUserModel,
    public createdAt: string
  ) {}
}

export class ActivityModel {
  constructor(
    public entity: string,
    public owner: string,
    public read: boolean,
    public text: string,
    public createdAt: string,
    public user: BlogUserModel,
    public post?: string
  ) {}
}

export class TitleValueMap {
  constructor(
    public title: string,
    public value: string,
    public date: Date,
    public foodLogs: FoodLogModel[],
    public waterlog: Waterlog,
    public weightlog: Weightlog,
    public meals?: Array<FoodLogModel[]>
  ) {}
}
